import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import FieldGroup from './FieldGroup'

class RegistrationModal extends Component {
  updateRegEmail = e => {
    return this.props.updateRegEmail({ email: e.target.value });
  }

  updateRegPassword = e => {
    return this.props.updateRegPassword({ password: e.target.value });
  }

  updateRegPasswordAgain = e => {
    return this.props.updateRegPasswordAgain({ passwordAgain: e.target.value });
  }

  registrationUser = e => {
    e.preventDefault();
    return this.props.registrationUser({
      username: this.props.registrationForm.email,
      password: this.props.registrationForm.password,
    });
  }

  render() {
    if (this.props.registrationModalState === 'close') {
      return null;
    }

    const { message, isRequest, isValid } = this.props.registrationForm;
    const { email, password, passwordAgain, validation } = this.props.registrationForm;

    return (
      <div className="static-modal">
        <Modal show={true}>
          <form onSubmit={this.registrationUser}>
            <Modal.Header closeButton onHide={this.props.toggleRegistrationModal}>
              <Modal.Title>Регистрация</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <FieldGroup
                help={validation.email ? validation.email[0] : null}
                value={email} disabled={isRequest ? true : false}
                onChange={this.updateRegEmail}
                validationState={validation.email ? "error" : "success"}
                id="email"
                type="text"
                label="E-mail"
                placeholder="Введите e-mail..."
              />
              <FieldGroup
                help={validation.password ? validation.password[0] : null}
                value={password} disabled={isRequest ? true : false}
                onChange={this.updateRegPassword}
                validationState={validation.password ? "error" : "success"}
                id="password"
                type="password"
                label="Пароль"
                placeholder="Введите пароль..."
              />
              <FieldGroup
                help={validation.passwordAgain ? validation.passwordAgain[0] : null}
                value={passwordAgain}
                disabled={isRequest ? true : false}
                onChange={this.updateRegPasswordAgain}
                validationState={validation.passwordAgain ? "error" : "success"}
                id="passwordAgain"
                type="password"
                label="Пароль повторно"
                placeholder="Введите пароль повторно..."
              />
              {message ? (<div className="alert alert-danger">{message}</div>) : null}
            </Modal.Body>

            <Modal.Footer>
              <Button disabled={isRequest || !isValid ? true : false} type="submit" bsStyle="primary">Зарегистрироваться</Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

export default RegistrationModal;



// WEBPACK FOOTER //
// ./src/components/RegistrationModal.js